/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Tier_Free_Feature_1Inputs */

const en_pricing_tier_free_feature_1 = /** @type {(inputs: Pricing_Tier_Free_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listen anywhere, on the go!`)
};

const es_pricing_tier_free_feature_1 = /** @type {(inputs: Pricing_Tier_Free_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Escucha en cualquier lugar, donde quieras!`)
};

/**
* | output |
* | --- |
* | "Listen anywhere, on the go!" |
*
* @param {Pricing_Tier_Free_Feature_1Inputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_tier_free_feature_1 = /** @type {((inputs?: Pricing_Tier_Free_Feature_1Inputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Tier_Free_Feature_1Inputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_tier_free_feature_1(inputs)
	return en_pricing_tier_free_feature_1(inputs)
});